/** Remove zero-width characters  */
export const sanitizeString = (str: string): string => {
  return str.replace(/[\u200B-\u200D\uFEFF]/g, '')
}
